import { Link, useLocation } from "react-router-dom";
import { Home, Compass, Heart, User } from "lucide-react";
import { FaYoutube } from "react-icons/fa";

const items = [
  { to: "/", label: "Home", icon: Home, testId: "nav-home" },
  { to: "/explore", label: "Explore", icon: Compass, testId: "nav-explore" },
  { to: "/banglatok", label: "BanglaTok", icon: FaYoutube, testId: "nav-banglatok", center: true },
  { to: "/saved", label: "Saved", icon: Heart, testId: "nav-saved" },
  { to: "/profile", label: "Profile", icon: User, testId: "nav-profile" },
];

export function BottomNav() {
  const loc = useLocation();
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 w-full sm:max-w-md sm:left-1/2 sm:-translate-x-1/2 z-50
                 bg-bg/90 backdrop-blur-xl border-t border-white/10 pt-2 pb-3 px-4
                 flex justify-between items-end"
    >
      {items.map((it) => {
        const active = loc.pathname === it.to;
        const Icon = it.icon;
        if (it.center) {
          return (
            <Link
              key={it.to}
              to={it.to}
              data-testid={it.testId}
              className="flex flex-col items-center gap-1 group"
            >
              <span className="relative -top-4 bg-gradient-to-tr from-brand to-orange-500 w-12 h-12 rounded-2xl flex items-center justify-center text-white shadow-lg shadow-brand/30 transition-transform group-hover:-translate-y-0.5">
                <Icon size={22} />
              </span>
              <span className={`text-[10px] -mt-3 ${active ? "text-brand" : "text-white/60"}`}>
                {it.label}
              </span>
            </Link>
          );
        }
        return (
          <Link
            key={it.to}
            to={it.to}
            data-testid={it.testId}
            className={`flex flex-col items-center gap-1 transition-colors ${
              active ? "text-brand" : "text-white/55 hover:text-white"
            }`}
          >
            <Icon size={20} strokeWidth={active ? 2.4 : 1.8} />
            <span className="text-[10px] font-medium">{it.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
